module.exports = __webpack_public_path__ + "img/9.e7d4b45f.png";